/**
 * Слияние ленты: серверные сообщения + очередь устройства.
 *
 * Чистые функции без React и IndexedDB — потому что именно здесь
 * решается, что увидит водитель в туннеле, и это должно проверяться
 * юнитами, а не глазами.
 */

/**
 * Смержить очередь в ленту.
 *
 * Правило одно: как только сервер знает сообщение (совпал
 * client_message_id), локальная копия из очереди исчезает —
 * серверная версия всегда полнее (настоящий id, вложения с ключами).
 * Неподтверждённые — хвостом, в порядке постановки.
 */
export function mergeFeed(serverMessages = [], queuedMessages = []) {
  const known = new Set(serverMessages.map((m) => m.client_message_id))
  const tail = queuedMessages.filter((q) => !known.has(q.client_message_id))
  return [...serverMessages, ...tail]
}

/**
 * Статус собственного сообщения для пузыря.
 *
 *   failed — очередь исчерпала попытки либо получила постоянный отказ;
 *   queued — ещё на устройстве;
 *   read   — КТО-ТО из остальных участников дочитал до него;
 *   sent   — сервер принял, прочтения пока нет.
 *
 * «Кто-то», а не «все»: в группе на полсотни человек двойная галочка
 * «все прочли» не наступает никогда и перестаёт что-либо значить.
 */
export function ownMessageStatus(message, members = [], myUserId = null) {
  if (message.failed) return 'failed'
  if (message.queued) return 'queued'
  const readBySomeone = members.some(
    (m) =>
      m.user_id !== myUserId &&
      m.last_read_message_id != null &&
      m.last_read_message_id >= message.id
  )
  return readBySomeone ? 'read' : 'sent'
}

/** Время для ленты: сегодня — часы, раньше — короткая дата. */
export function messageTimeLabel(iso) {
  if (!iso) return ''
  const d = new Date(iso)
  const now = new Date()
  const sameDay =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  return sameDay
    ? d.toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('ru', { day: '2-digit', month: '2-digit' })
}
